module.exports = __webpack_public_path__ + "82f5c5b1e6881cde336afb09a0b0da5f.jpg";